import { http } from '@noor/api';
import { env } from '@noor/config';
import { serviceFeeSchema, type ServiceFeeSettings } from '../model/schema';

const eatsBase = { baseURL: env.VITE_EATS_API_URL };
const path = '/api/v1/admin/settings/service-fee';

function unwrap(raw: unknown): ServiceFeeSettings {
  const root = (raw ?? {}) as Record<string, unknown>;
  const body = (root.data ?? raw ?? {}) as Record<string, unknown>;
  // A GET that predates the order-amount fields omits them; 0 reads as
  // "no minimum / no surcharge". Defaulted here, not in the schema, so the
  // schema's input and output types stay one shape for the form resolver.
  return serviceFeeSchema.parse({ min_order_amount: 0, low_order_fee: 0, ...body });
}

export const serviceFeeApi = {
  async get(): Promise<ServiceFeeSettings> {
    return unwrap(await http.get<unknown>(path, eatsBase));
  },
  async update(payload: ServiceFeeSettings): Promise<ServiceFeeSettings> {
    return unwrap(await http.put<unknown>(path, payload, eatsBase));
  },
};
